import React, { useState, useEffect } from 'react';
import { Typography, Button, Card, Row, Col } from 'antd';
import { 
  HomeOutlined, 
  ArrowLeftOutlined, 
  FileSearchOutlined,
  FrownOutlined,
  RocketOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { posts } from '../../api/mockData';
import './index.css';

const { Title, Text } = Typography;

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalPosts: 0,
    totalTags: 0
  });

  useEffect(() => {
    // 计算统计数据
    const totalPosts = posts.length;
    const totalTags = [...new Set(posts.flatMap(post => post.tags))].length;
    
    setStats({ totalPosts, totalTags });
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <FrownOutlined className="not-found-icon" />
        
        <Title className="not-found-title">404</Title>
        
        <Title level={3} className="not-found-subtitle">
          哎呀！页面走丢了
        </Title>
        
        <Text className="not-found-subtitle" style={{ display: 'block', marginBottom: '32px' }}>
          您访问的页面可能已被移动、删除或暂时不可用。别担心，我们的博客里还有很多精彩内容等您发现！
        </Text>
        
        <div className="not-found-actions">
          <Button 
            type="primary"
            icon={<HomeOutlined />}
            className="action-button primary"
            onClick={() => navigate('/')}
            size="large"
          >
            返回首页
          </Button>
          
          <Button 
            icon={<ArrowLeftOutlined />}
            className="action-button secondary"
            onClick={() => navigate(-1)}
            size="large"
          >
            返回上一页
          </Button>
          
          <Button 
            icon={<FileSearchOutlined />}
            className="action-button secondary"
            onClick={() => navigate('/archive')}
            size="large"
          >
            浏览归档
          </Button>
        </div>
        
        <div className="not-found-stats">
          <div className="stat-item">
            <div className="stat-number">{stats.totalPosts}</div>
            <Text className="stat-label">篇文章</Text>
          </div>
          
          <div className="stat-item">
            <div className="stat-number">{stats.totalTags}</div>
            <Text className="stat-label">个标签</Text>
          </div>
          
          <div className="stat-item">
            <div className="stat-number">7</div>
            <Text className="stat-label">个页面</Text>
          </div>
          
          <div className="stat-item">
            <div className="stat-number">
              <RocketOutlined />
            </div>
            <Text className="stat-label">持续更新</Text>
          </div>
        </div>
        
        <Card 
          style={{ 
            marginTop: '48px', 
            background: 'rgba(255, 255, 255, 0.1)', 
            border: 'none',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Text style={{ color: 'white', opacity: 0.9 }}>
                <strong>可能的原因：</strong>
              </Text>
              <ul style={{ color: 'white', opacity: 0.8, textAlign: 'left', paddingLeft: '20px' }}>
                <li>页面地址输入错误</li>
                <li>文章可能已被删除</li>
                <li>页面正在维护中</li>
                <li>链接已过期</li>
              </ul>
            </Col>
            
            <Col xs={24} md={12}>
              <Text style={{ color: 'white', opacity: 0.9 }}>
                <strong>推荐操作：</strong>
              </Text>
              <ul style={{ color: 'white', opacity: 0.8, textAlign: 'left', paddingLeft: '20px' }}>
                <li>检查地址拼写是否正确</li>
                <li>使用搜索功能查找内容</li>
                <li>浏览最新文章列表</li>
                <li>联系管理员反馈问题</li>
              </ul>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default NotFoundPage;